import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ElectricDetailView } from "./component";
import { Product } from "../../../../components/Reusable/type";
import { fetchElectricPlans } from "../../../../features/auth/store/electricPlanSlice";
import { AppDispatch, RootState } from "../../../../redux/store";
import Electric from "./Electric";
import { fetchElectricCategories } from "../../../../features/auth/store/electricCategorySlice";
import { fetchCountries } from "../../../../features/auth/store/countrySlice";
import { SortBy, SortOrder } from "../../../../features/auth/store/types/types";

const ElectricRouter: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [categoryFilter, setCategoryFilter] = useState<string>("");
  const [countryFilter, setCountryFilter] = useState<string>("");
  const [sortBy, setSortBy] = useState<SortBy | "">("created_at");
  const [sortOrder, setSortOrder] = useState<SortOrder | "">("desc");
  const [selectedElectricPlan, setSelectedElectricPlan] =
    useState<Product | null>(null);
  const [showDetailView, setShowDetailView] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const { electricPlans, loading, error } = useSelector(
    (state: RootState) => state.electricPlans,
  );

  const { electricCategories } = useSelector(
    (state: RootState) => state.electricCategories,
  );

  const isMounted = useRef(false);

  useEffect(() => {
    if (!electricCategories || electricCategories.length == 0) {
      dispatch(fetchElectricCategories({ perPage: 100 }));
    }
    dispatch(fetchCountries({ page: 1, perPage: 100 }));
  }, []);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      dispatch(fetchElectricPlans({}));
      return;
    }
    const handler = setTimeout(() => {
      const filters: Record<string, any> = {};

      if (statusFilter) filters.status = statusFilter;
      if (categoryFilter) filters.category = categoryFilter; // ID sent
      if (countryFilter) filters.country = countryFilter; // ID sent
      if (sortBy) filters.sort_by = sortBy;
      if (sortOrder) filters.sort_order = sortOrder;
      if (searchTerm.trim()) filters.search = searchTerm.trim();

      dispatch(fetchElectricPlans(filters));
    }, 350);

    return () => clearTimeout(handler);
  }, [
    dispatch,
    statusFilter,
    categoryFilter,
    countryFilter,
    sortBy,
    sortOrder,
    searchTerm,
  ]);
  // Transform DataPlan to Product - ensuring all required fields are present

  const handleElectricPlanClick = (dataPlan: Product) => {
    setSelectedElectricPlan(dataPlan);
    setShowDetailView(true);
  };

  const handleBackToList = () => {
    setShowDetailView(false);
    setSelectedElectricPlan(null);
  };

  if (showDetailView && selectedElectricPlan) {
    return (
      <ElectricDetailView
        electricPlan={{
          ...selectedElectricPlan,
        }}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <Electric
      electricPlans={electricPlans || []}
      loading={loading}
      error={error}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      onElectricPlanClick={handleElectricPlanClick}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      categoryFilter={categoryFilter}
      setCategoryFilter={setCategoryFilter}
      countryFilter={countryFilter}
      setCountryFilter={setCountryFilter}
      sortBy={sortBy}
      setSortBy={setSortBy}
      sortOrder={sortOrder}
      setSortOrder={setSortOrder}
    />
  );
};

export default ElectricRouter;
